import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = ({ canonical, title, description, image }) => {
  const location = useLocation();
  const siteUrl = import.meta.env.VITE_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "https://harisharandevgan.com");
  const url = canonical || `${siteUrl}${location.pathname}${location.search || ""}`;

  return (
    <Helmet>
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}
    </Helmet>
  );
};

export default SEO;
